import React, { createContext, useState } from "react";
import { toast } from "react-toastify";

import { createTranscriptApi } from "../api/Writes";

export const PGTranscriptRequestContext = createContext(null);

const PGTranscriptRequestProvider = ({ children }) => {
  const [pgTranscriptInfo, setPgTranscriptInfo] = useState({});
  const [pgTranscriptOption, setPgTranscriptOption] = useState();
  const [copyType, setCopyType] = useState();
  const [educationType, setEducationType] = useState();
  const [requestType, setRequestType] = useState();
  const [pgTranscriptOrderNo, setPgTranscriptOrderNo] = useState("");

  //  create transcript
  const createTranscript = async (param) => {
    try {
      let response = await createTranscriptApi(param);
      if (response.success) {
        toast.success("Transcript saved successfully");
        return response.data.requestOrderNumber;
      } else {
        toast.error(response.message || "Oops, Something went wrong");
      }
    } catch ({ response }) {
      const { message } = response?.data;
      toast.error(message || "Oops, Something went wrong");
    }
  };

  return (
    <PGTranscriptRequestContext.Provider
      value={{
        createTranscript,
        pgTranscriptInfo,
        setPgTranscriptInfo,
        pgTranscriptOption,
        setPgTranscriptOption,
        copyType,
        setCopyType,
        requestType,
        setRequestType,
        pgTranscriptOrderNo,
        setPgTranscriptOrderNo,
        educationType,
        setEducationType,
      }}
    >
      {children}
    </PGTranscriptRequestContext.Provider>
  );
};
export default PGTranscriptRequestProvider;
